import { useCallback } from 'react'
import { UseData } from './useData'
import { Props as SelectProps } from '../DiscountCodeSelect'
import { IDiscountCode } from '@user/store/discountCode/typings'

type Props = Pick<UseData, 'discountCodes' | 'setValue'> &
  Pick<SelectProps, 'onChange'>

export function useHandlers(props: Props) {
  const { onChange, setValue } = props

  const handleTidalChange = useCallback(
    (value: IDiscountCode | null) => {
      setValue(value)
      if (onChange) {
        onChange(value?.id.toString() ?? '', value?.code ?? '')
      }
    },
    [setValue, onChange],
  )

  const handleChange = useCallback(
    (_event: React.SyntheticEvent<Element, Event>, value: IDiscountCode) => {
      setValue(value)
      if (onChange) {
        onChange(value?.id.toString() ?? '', value?.code ?? '')
      }
    },
    [setValue, onChange],
  )

  return { handleChange, handleTidalChange } as const
}
